import React from 'react';
import { useI18n } from '../../context/i18n';
import { billingTranslations } from './billingCopy';
import './CapacityBanner.css';

// Reusable "at capacity" banner. Renders wherever a new opportunity would be
// created (chat, Golden Opportunities, dashboard) when the account has no
// free Active Revenue Opportunity slots left. Never blocks silently — always
// explains why and offers a way out (free a slot, or upgrade).
export default function CapacityBanner({ onViewPlans, className = '' }) {
  const { language } = useI18n();
  const copy = billingTranslations[language]?.capacity || billingTranslations.en.capacity;

  return (
    <div className={`capacity-banner ${className}`} role="status">
      <div className="capacity-banner-icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" />
          <path d="M10 6.5v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="10" cy="13.2" r="0.9" fill="currentColor" />
        </svg>
      </div>
      <div className="capacity-banner-text">
        <span className="capacity-banner-title">{copy.title}</span>
        <span className="capacity-banner-body">{copy.body}</span>
      </div>
      <button type="button" className="capacity-banner-cta" onClick={onViewPlans}>
        {copy.cta}
      </button>
    </div>
  );
}
